<button *ngIf="(isAuthenticated | async)" class="dropdown-item"
        [routerLink]="['/auditlogs/object/', contextMenuObject.id]">
  {{'context-menu.actions.audit-item.btn' | translate}}
</button>
